import React from "react";

export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="10" y="3" width="4" height="10" rx="2" fill="#fff" />
      <path
        d="M6 11a6 6 0 0 0 12 0"
        stroke="#fff"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path d="M12 17v4M9 21h6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
